import React, { useState, } from "react";
import { Upload } from '@appkit4/react-components/upload';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import $ from 'jquery';
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { addUploadedFiles } from "../../store/chatSlice";
import Loader from '../Loader/Loader';
import api from "../../apis/api";
import { sessionTimeout } from "../../store/authSlice";

const UploadSample = (props: any) => {
  const dispatch = useDispatch<AppDispatch>()
  const [loading, setLoading] = useState<Boolean>(false);
  const azuresearchId = useSelector((state: RootState) => state.auth.azuresearchId)
  const onChange = (file: File, fileList: FileList): void => {
  }

  const closeModelPop = (): void => {
    $('.ap-fileupload-fileList').hide()
    props.closeDataModel();
  };

  const onClose = (fileList: FileList): void => {
  }
  const uploadFiles = async (fileList: any) => {
    const files = fileList
    if (!files || files.length === 0) {
      alert('No file selected')
      return
    }
    const formData = new FormData()
    const fileArr = [];
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i].originFile)
      // Calculate size in KB and MB
      const sizeInKB = (files[i].originFile.size / 1024).toFixed(2) + ' KB';
      const sizeInMB = (files[i].originFile.size / (1024 * 1024)).toFixed(2) + ' MB';
      const displaySize = files[i].originFile.size < (1024 * 1024) ? sizeInKB : sizeInMB;
      fileArr.push({ name: files[i].originFile.name, size: displaySize });
    }

    formData.append('azuresearchId', azuresearchId)
    setLoading(true);
    try {
      const idmuploadurl = process.env.REACT_APP_IDMUPLOAD
      if (!idmuploadurl) {
        throw Error('API url is missing')
      }
      const response = await api.post(idmuploadurl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      if (response.data === "File Uploaded successfully") {
        const currentMsgDate = new Date().toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });
        dispatch(addUploadedFiles({ sender: 'file', currentModule: 'idm', files: fileArr, fileUploadedTime: currentMsgDate }));
        toast.success("File uploaded successfully", {
          position: "top-right",
        });
      }
    }
    catch (err: any) {
      console.error(err)
      if (err.status === 500) {
        toast.error(err.response.data.error, {
          position: "top-right",
          autoClose: 5000
        });
      }
      else if (err.status === 401) {
        toast.error(err.response.data.error, {
          position: "top-right",
          autoClose: 5000
        });
        dispatch(sessionTimeout(true))
      }
      else {
        toast.error("File upload failed!", {
          position: "top-right",
        });
      }
    }
    finally {
      setLoading(false);

    }
    closeModelPop()
  }

  return (
    <>
      {loading ? <Loader /> : <Upload
        onChange={onChange}
        multiple={true}
        autoUpload={false}
        onClose={onClose}
        onUpload={uploadFiles}
        acceptFileType=".PDF"
        uploadInstruction="You can upload PDF files. The max file size is 10mb."
        uploadTitle="Upload your files"
        maxFileSize={10 * 1024 * 1024} action="/"
        config={{
          trigger: true,
          type: 'inline',
          size: true
        }}
      >
      </Upload>}
      <ToastContainer autoClose={500} />
    </>
  );
}

export default UploadSample
